<template>
    <div>
        <base-loading :visible="isLoading" />
        <confirmation-modal 
            :isOpen="confirmation" 
            @close="confirmation = false" 
            @accept="deleteItem"
            :item="selectedItem" />
        <edit-item-modal 
            :isOpen="editItem" 
            @close="editItem = false" 
            :item="selectedItem" 
            :rangeList="rangeList" 
            @update="updateItem" />
        <BaseSidebar :visible.sync="isOpen" title="edit" size="md">
            <template v-slot:body>

                <vs-row class="mb-4">
                    <vs-col class="px-2">
                        <vs-input :label="$t('client') | capitalize" :placeholder="$t('client') | capitalize"
                            v-model="client" class="w-full" disabled />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('entry_id') | capitalize" :placeholder="$t('entry_id') | capitalize"
                            v-model="entryId" class="w-full" disabled />
                    </vs-col>
                    <vs-col class="px-2" vs-w="6">
                        <vs-input :label="$t('folio') | capitalize" :placeholder="$t('folio') | capitalize"
                            v-model="folio" class="w-full" disabled />
                    </vs-col>
                </vs-row>

                <vs-row class="mb-4">
                    <vs-col vs-w="6" class="px-2">
                        <vs-input :label="$t('iva') | upperCase" :placeholder="$t('iva') | upperCase" v-model="iva"
                            class="w-full" disabled />
                    </vs-col>
                    <vs-col vs-w="6" class="px-2">
                        <vs-input :label="$t('currency') | capitalize" :placeholder="$t('currency') | capitalize"
                            v-model="currency" class="w-full" disabled />
                    </vs-col>
                </vs-row>

                <vs-row class="mb-4">
                     <vs-col class="px-4" vs-w="12">
                        <label>{{ $t('comments') | capitalize }}</label>
                    </vs-col>
                    <vs-col class="px-2" vs-w="12">
                        <vs-textarea
                            v-model="comments" class="no-resize" />
                    </vs-col>
                </vs-row>
                <vs-row class="mb-4">
                    <vs-col class="px-2">
                        <items-table :items="containerList" @edit="handleEdit" @delete="handleDelete" />
                    </vs-col>
                </vs-row>
                <vs-row>

                </vs-row>
            </template>

            <template v-slot:footer>
                <vs-button color="primary" type="border" @click="$emit('close')">{{ $t('cancel') }}</vs-button>
                <vs-button color="success" @click="handleSubmit">{{ $t('save') }}</vs-button>
            </template>
        </BaseSidebar>
    </div>
</template>

<script>
import BaseSidebar from '@/views/app/components/sidebar/BaseSidebar.vue'
import ItemsTable from './ItemsTable.vue';
import EditItemModal from './EditItemModal.vue';
import ConfirmationModal from '@/views/app/components/modals/ConfirmationModal.vue'
import BaseLoading from '@/views/app/components/loading/BaseLoading.vue';
import request from '../request';

export default {
    name: 'EditExpense',
    components: { BaseSidebar, ItemsTable, ConfirmationModal, EditItemModal, BaseLoading },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
            default: false
        },

        itemId: {
            type: [Number, String],
            required: true,
            default: ''
        },
    },
    data() {
        return {
            confirmation: false,
            editItem: false,
            selectedItem: {},
            aging: '',
            approved: '',
            client: '',
            clientId: '',
            entryId: '',
            folio: '',
            preTotal: '',
            shipped: '',
            total: '',
            iva: '0%',
            currency: 'USD',
            comments:'',
            containerList: [],
            rangeList: [],
            loading: {
                expense: false,
                range: false,
                submit: false
            },
        }
    },
    computed: {
        isLoading() {
            return this.loading.expense || this.loading.range | this.loading.submit
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.getExpense()
            }
        }
    },
    methods: {

        getExpense() {
            const payload = { id: this.itemId }
            this.loading.expense = true
            request.getExpense(payload)
                .then(response => {
                    this.aging = response.data.pre_expense.aging,
                    this.approved = response.data.pre_expense.approved,
                    this.client = response.data.pre_expense.ClientName,
                    this.clientId = response.data.pre_expense.client_id,
                    this.entryId = response.data.pre_expense.entry_id,
                    this.folio = response.data.pre_expense.folio,
                    this.preTotal = response.data.pre_expense.pre_total,
                    this.shipped = response.data.pre_expense.shipped,
                    this.total = response.data.pre_expense.total
                    this.comments = response.data.pre_expense.comments   
                    const containers = response.data.containers.map( (el) => ({...el,active: el.delete_at == null ? true :  false}) )
                    this.containerList = [ ...containers ]
                    this.loading.expense = false
                    this.getRanges()
                })
                .catch(response => {
                    //console.log(response)
                    this.loading.expense = false
                })
        },

        getRanges() {
            this.rangeList = []
            this.loading.range = true
            const payload = { client_id: this.clientId }
            request.getRanges(payload)
                .then(response => {
                    this.rangeList = [...response.data]
                    this.loading.range = false
                })
                .catch(response => {
                    this.loading.range = false
                })
        },

        handleEdit(item) {
            this.selectedItem = { ...item }
            this.editItem = true
        },

        updateItem(item){
            const find = this.containerList.find(el => el.id === item.id);
            if (find) {
                find.range = item.range
                find.range_id = item.rangeId
                find.days = item.days
                find.unit_price = item.unitPrice
                find.total = item.total
            }
        },

        handleDelete(item) {
            this.selectedItem = { ...item }
            this.confirmation = true

        },
        deleteItem(item) {
            this.confirmation = false
            const find = this.containerList.find(el => el.id === item.id);
            if (find) {
                find.active = false
            }
        },
        handleSubmit() {
            const payload = {
                id: this.itemId,
                comments: this.comments,
                containers:this.containerList
            }
            this.loading.submit = true
            request.updateExpese(payload)
                .then(response => {
                    this.loading.submit = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Updated',
                    })
                    this.$emit('close')
                    this.$emit('update');
                })
                .catch(response => {
                    this.loading.submit = false
                    this.$vs.notify({
                        color: 'warning',
                        title: 'Oops!',
                        text: 'An error occurred during the update process.'
                    })
                })

        },

    },
}
</script>

<style>
.no-resize textarea {
  resize: none;
}
</style>